<script>
import { PrivateKeyType } from '../models/sign-constants';
export default {
  name: 'AppSignBaseTab',
  inject: ['isMobileOnly'],
  props: {
    certificateAuthority: { default: null },
    disabled: { default: false },
    eventBus: { default: null },
    useUserCertificates: { default: false },
    privateKeyType: { type: String, default: '' },
    shouldValidateKeyType: { type: Boolean, default: false }
  },
  data() {
    return {
      isSignKeyReaded: false,
      signMethod: ''
    };
  },
  computed: {
    signingParamsRequestMsg() {
      return `SigningParams-Request-${this.privateKeyType}-${this.signMethod}`;
    },
    signingParamsResponseMsg() {
      return `SigningParams-Response-${this.privateKeyType}-${this.signMethod}`;
    },
    signingParamsRequestChildMsg() {
      return ``;
    },
    signingParamsResponseChildMsg() {
      return ``;
    },
    isSeal() {
      return this.privateKeyType === PrivateKeyType.Seal;
    }
  },
  mounted() {
    this.subscribe();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    onSignKeyReaded(e) {
      this.isSignKeyReaded = true;
      this.$emit('readed', e);
      this.$emit('ready');
    },
    onReady(e) {
      this.$emit('ready', e);
    },
    onNotReady(e) {
      this.$emit('not-ready', e);
      this.isSignKeyReaded = false;
    },
    reset() {
      this.isSignKeyReaded = false;
    },
    subscribe() {
      this.eventBus.$on('app-sign-reset-private-key', this.reset);
      this.eventBus.$on(
        this.signingParamsRequestMsg,
        this.onSigningParamsRequest
      );
    },
    unsubscribe() {
      this.eventBus.$off('app-sign-reset-private-key', this.reset);
      this.eventBus.$off(
        this.signingParamsRequestMsg,
        this.onSigningParamsRequest
      );
    },
    async onSigningParamsRequest() {
      let prms = await this.getSigningParams();
      this.eventBus.$emit(this.signingParamsResponseMsg, prms);
    },
    async getSigningParams() {
      return new Promise((resolve) => {
        const fn = (prms) => {
          this.eventBus.$off(this.signingParamsResponseChildMsg);
          resolve(prms);
        };
        this.eventBus.$on(this.signingParamsResponseChildMsg, fn);
        this.eventBus.$emit(this.signingParamsRequestChildMsg);
      });
    }
  }
};
</script>
